export default __webpack_public_path__ + "static/media/yourprojectsgroupbutton@2x.a51bd8f2.png";